var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 90,
    cy: 90,
    r: 89.25,
    fill: "#082D0F",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 152,
    r: 20,
    fill: "#43FF86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 156.586L144.707 152.793C144.317 152.402 143.683 152.402 143.293 152.793C142.902 153.183 142.902 153.817 143.293 154.207L147.793 158.707C148.183 159.098 148.817 159.098 149.207 158.707L160.207 147.707C160.598 147.317 160.598 146.683 160.207 146.293C159.817 145.902 159.183 145.902 158.793 146.293L148.5 156.586Z",
    fill: "#082D0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3941 90.825L62.014 96.055C61.279 96.1775 60.6654 96.6832 60.4048 97.3812L49.5802 126.37C48.5441 129.035 51.3334 131.577 53.8903 130.298L128.89 92.7981C131.194 91.6464 131.194 88.3596 128.89 87.2079L53.8903 49.7079C51.3334 48.4295 48.5441 50.9713 49.5802 53.6356L60.4048 82.6248C60.6654 83.3228 61.279 83.8285 62.014 83.951L93.3941 89.181C93.8481 89.2567 94.1548 89.686 94.0791 90.14C94.0206 90.4912 93.7453 90.7665 93.3941 90.825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLargeIcon);
export default __webpack_public_path__ + "static/media/send_large_icon.0d4630ade15fd2445b43b01a7dd735f3.svg";
export { ForwardRef as ReactComponent };